<template>
  <div class="wrapper">
    <el-form-item :prop="getPropName">
      <el-input :value="value" @input="onInput"></el-input>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'table-input',

  props: {
    value: null,
    name: String,
    scope: null,
  },

  computed: {
    /**
     * @return {string|null}
     */
    getPropName() {
      if (!_.isUndefined(this.scope)) {
        return `${this.scope}.${this.name}`;
      }

      return null;
    },
  },

  methods: {
    /**
     * @param {*} value
     */
    onInput(value) {
      this.$emit('input', {name: this.name, value});
    },
  },
}
</script>

<style scoped>
.wrapper >>> .el-form-item__content {
  margin-left: 0 !important;
}
</style>
